import {
  FragmentType,
  getFragmentData,
  graphql,
} from "../../__generated__/gql";
import Dropdown from "../../ui/Dropdown/Dropdown";
import TeamCard from "../TeamCard/TeamCard";
import styles from "./TeamSelector.module.scss";
import { BillingTier } from "../../__generated__/gql/graphql";

export const TeamSelectorQueryFragment = graphql(/* GraphQL */ `
  fragment TeamSelectorQuery on Query {
    memberships {
      id
      identityId
      billingTier
      name
      memberCount
    }
  }
`);

type Team = {
  id: string;
  identityId: string;
  billingTier: BillingTier;
  name: string;
  memberCount: number;
};

function TeamSelector({
  data,
  onClick,
  filter,
  children,
  showChevron,
}: {
  data?: FragmentType<typeof TeamSelectorQueryFragment>;
  onClick: (team: Team) => void | Promise<void>;
  filter?: (team: Team) => boolean;
  children: React.ReactNode;
  showChevron?: boolean;
}) {
  const query = getFragmentData(TeamSelectorQueryFragment, data);

  const items =
    query?.memberships.filter(filter ?? (() => true)).map((membership) => ({
      id: membership.id,
      label: (
        <TeamCard
          name={membership.name}
          memberCount={membership.memberCount}
          billingTier={membership.billingTier}
        />
      ),
      onClick: async () => onClick(membership),
    })) ?? [];

  return (
    <Dropdown
      withinPortal
      offsetAmount={0}
      matchWidth
      disabled={items.length === 0}
      classNames={{
        button: styles.teamSelectorButton,
        menu: styles.teamSelectorDropdown,
      }}
      items={[
        {
          items,
        },
      ]}
      showChevron={showChevron}
    >
      {children}
    </Dropdown>
  );
}

export default TeamSelector;
